import '@fortawesome/fontawesome-pro/css/fontawesome'
import '@fortawesome/fontawesome-pro/css/brands'
import '@fortawesome/fontawesome-pro/css/regular'
import '@fortawesome/fontawesome-pro/css/light'
import '@fortawesome/fontawesome-pro/css/thin'
import '@fortawesome/fontawesome-pro/css/solid'
import '@fortawesome/fontawesome-pro/css/duotone'
import * as bootstrap from 'bootstrap'
import 'javascripts/theme/app.js'

import "stylesheets/theme/bootstrap.scss";
import "stylesheets/theme/app.scss";

window.bootstrap = bootstrap;